import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { replaceAccents } from '@app/shared/utils';
import { Actions, ofActionDispatched, Select } from '@ngxs/store';
import { SchedulerCoreState } from '@radioking/scheduler-core';
import { MobileSidenavService } from '@radioking/shared/common-services';
import { SugestionInput } from '@radioking/ui/input';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProgramAddPlaylistSuccess } from '../../../states/programs.actions';

@Component({
  selector: 'rk-mob-program-change-playlist',
  templateUrl: './mob-program-change-playlist.component.html',
  styleUrls: ['./mob-program-change-playlist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobProgramChangePlaylistComponent implements OnInit, OnDestroy {
  addPlaylistForm: FormGroup;

  searchSubject = new BehaviorSubject<string>('');

  playlists$: Observable<SugestionInput[]>;

  @Select(SchedulerCoreState.allPlaylistsForDropdown)
  playlistsUnfiltered$: Observable<SugestionInput[]>;

  @Output()
  applyPlaylist = new EventEmitter<SugestionInput>();

  subscription = new Subscription();

  constructor(
    private readonly mobileService: MobileSidenavService,
    private readonly actions$: Actions,
  ) {}

  ngOnInit() {
    this.playlists$ = combineLatest([
      this.playlistsUnfiltered$,
      this.searchSubject.asObservable(),
    ]).pipe(
      map(([playlists, search]) => {
        const searchTerm = replaceAccents(search.toLowerCase());
        return playlists.filter(pl =>
          replaceAccents(pl.name.toLowerCase()).includes(searchTerm),
        );
      }),
    );

    this.subscription.add(
      this.actions$.pipe(ofActionDispatched(ProgramAddPlaylistSuccess)).subscribe(() => {
        this.mobileService.close();
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onChangeSearch(str: string) {
    this.searchSubject.next(str);
  }

  cancel() {
    this.mobileService.close();
  }

  selectPlaylist(playlist: SugestionInput) {
    this.applyPlaylist.emit(playlist);
  }
}
